export default "__VITE_ASSET__CWMT13_c__"